import { adminEvalExtractionAbsolutePath } from '@/admin/utils/routes'
import { canSaveAsExtractionGoldDraft } from '@/features/evals/utils/extractionGold'
import type { EvalExtractionType } from '@artem-lex/common-server/evals/standardExtraction'
import { useGetUserSession } from '@/shared/hooks/api/auth'
import { useCreateEvalExtractionTask } from '@/shared/hooks/api/evalExtraction'
import { useEvalSettings } from '@/shared/hooks/api/evals'
import { getApiErrorMessage } from '@/shared/utils/getApiErrorMessage'
import { Button } from '@/components/ui/button'
import { toast } from 'sonner'

type SaveAsExtractionGoldButtonProps = {
  userStandardId: string
  organizationId: string
  extractionType: EvalExtractionType
}

export function SaveAsExtractionGoldButton({
  userStandardId,
  organizationId,
  extractionType,
}: SaveAsExtractionGoldButtonProps) {
  const { data: session } = useGetUserSession()
  const isArtemAdmin = session?.isArtemAdmin === true
  const settingsQuery = useEvalSettings({ enabled: isArtemAdmin })
  const createMutation = useCreateEvalExtractionTask()

  if (
    !canSaveAsExtractionGoldDraft({
      isArtemAdmin,
      evalOrganizationId: settingsQuery.data?.organizationId,
      standardOrganizationId: organizationId,
    })
  ) {
    return null
  }

  return (
    <Button
      type='button'
      variant='outline'
      size='sm'
      disabled={createMutation.isPending}
      onClick={() => {
        void createMutation.mutateAsync(
          {
            userStandardId,
            extractionType,
            origin: 'PRODUCT_PREVIEW',
          },
          {
            onSuccess: (created) => {
              window.location.assign(
                adminEvalExtractionAbsolutePath(created.id)
              )
            },
            onError: (error) => {
              toast.error(getApiErrorMessage(error))
            },
          }
        )
      }}
    >
      Save as Gold draft
    </Button>
  )
}
